import ReportWithoutCriteria from '../ReportWithoutCriteria';
import {
  ASSIGNED_TO_WRITERS_REPORT_ERROR,
  ASSIGNED_TO_WRITERS_REPORT_LOADING,
  ASSIGNED_TO_WRITERS_REPORT_SUCCESS,
} from './reportStates';

export default function AssignedToWritersReport({
  generateAssignedToWritersReport,
  getLatestAssignedToWritersReport,
  assignedToWritersReportData,
  assignedToWritersReportState,
}) {
  return (
    <ReportWithoutCriteria
      name="Assigned to Writers Report"
      link={assignedToWritersReportData?.link}
      currentState={assignedToWritersReportState}
      stateLoading={ASSIGNED_TO_WRITERS_REPORT_LOADING}
      stateError={ASSIGNED_TO_WRITERS_REPORT_ERROR}
      stateSuccess={ASSIGNED_TO_WRITERS_REPORT_SUCCESS}
      getLatestFunc={getLatestAssignedToWritersReport}
      generateFunc={generateAssignedToWritersReport}
    />
  );
}
